// Icons
import { TbMoneybag } from "react-icons/tb";

// Types
import type { IPersonalProps } from "./types";

export function Personal(prps: IPersonalProps) {

    return (
        <span style={{
            maxWidth: 'calc(50% - 0.75rem)',
            minWidth: 'calc(50% - 0.75rem)',
        }} className="max-sm:!w-full max-sm:!min-w-full max-sm:!max-w-ful md:flex-1 h-auto flex flex-col justify-start gap-3
                rounded-xl
                border-slate-200 border-[1px]
                bg-white shadow-md overflow-hidden
            "
        >
            <span className="w-full flex flex-row items-center gap-2 px-4 pt-4 pb-2 border-slate-200 border-b-[1px]">
                <TbMoneybag size={25} />
                <span className="font-semibold">Impostos</span>
            </span>

            <span className="w-full h-auto flex flex-col gap-3 p-4">
                <input type="radio" name="personal_option" id="personal_pf" className="peer/PF hidden" />
                <input type="radio" name="personal_option" id="personal_pj_presumido" className="peer/PJPresumido hidden" />
                <input type="radio" name="personal_option" id="personal_pj_ret" className="peer/PJRET hidden" />

                <label title="Clique para selecionar" htmlFor="personal_pf" onClick={() => prps.setFeeAmount(prps.personaF)} className="w-full h-auto cursor-pointer
                    flex flex-row items-center justify-between gap-4 
                    peer-checked/PF:p-2 peer-checked/PF:bg-slate-200 rounded-xl hover:bg-slate-100"
                >
                    <span>Pessoa Física</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                            }).format(prps.personaF)
                        }
                    </span>
                </label>

                <label title="Clique para selecionar" htmlFor="personal_pj_presumido" onClick={() => prps.setFeeAmount(prps.personaJP)} className="w-full h-auto cursor-pointer
                    flex flex-row items-center justify-between gap-4 
                    peer-checked/PJPresumido:p-2 peer-checked/PJPresumido:bg-slate-200 rounded-xl hover:bg-slate-100"
                >
                    <span>Pessoa Jurídica Presumido</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                            }).format(prps.personaJP)
                        }
                    </span>
                </label>

                <label title="Clique para selecionar" htmlFor="personal_pj_ret" onClick={() => prps.setFeeAmount(prps.personaJR)} className="w-full h-auto cursor-pointer
                    flex flex-row items-center justify-between gap-4 
                    peer-checked/PJRET:p-2 peer-checked/PJRET:bg-slate-200 rounded-xl hover:bg-slate-100"
                >
                    <span>Pessoa Jurídica RET</span>
                    <span className="font-semibold">
                        {
                            Intl.NumberFormat('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                            }).format(prps.personaJR)
                        }
                    </span>
                </label>
            </span>
        </span>
    )
}
